import { DocumentsActionButton } from "./DocumentsActionButton";
import { DocumentDownload, Edit, TrashCan, Template } from "@carbon/icons-react";
import { Button } from "../../atom/Button";
import React from "react";
import { ParticipantFile, ParticipantFileStatusCode } from "../../../types/components";
import { useTranslation } from "react-i18next";
import {
  isStatusApproved,
  isStatusNotUploaded,
  isStatusPendingApproval,
} from "../../../utils/status";
import { download } from "../../../utils/file";

interface DocumentActionsProps {
  participantFile: ParticipantFile;
  code: ParticipantFileStatusCode;
  setCurrentFile: React.Dispatch<React.SetStateAction<ParticipantFile | null>>;
  setIsRemoveModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setIsUploadModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  typeCode: string;
}

export const DocumentActions: React.FC<DocumentActionsProps> = ({
  participantFile,
  code,
  setIsUploadModalOpen,
  setIsRemoveModalOpen,
  setCurrentFile,
  typeCode,
}) => {
  const { t } = useTranslation();

  return (
    <div>
      {!isStatusNotUploaded(code) ? (
        <div className="flex items-center justify-center gap-3">
          <DocumentsActionButton
            label={t("Download")}
            disabled={isStatusPendingApproval(code)}
            icon={DocumentDownload}
            onClick={() => download(participantFile?.file)}
          />
          <DocumentsActionButton
            label={t("Edit")}
            disabled={isStatusPendingApproval(code) || isStatusApproved(code)}
            icon={Edit}
            onClick={() => {
              setCurrentFile(participantFile);
              setIsUploadModalOpen(true);
            }}
          />
          <DocumentsActionButton
            label={t("Remove")}
            disabled={isStatusPendingApproval(code) || isStatusApproved(code)}
            icon={TrashCan}
            onClick={() => {
              setCurrentFile(participantFile);
              setIsRemoveModalOpen(true);
            }}
          />
        </div>
      ) : null}
      {isStatusNotUploaded(code) && typeCode !== "certificate" ? (
        <div className="flex items-center gap-3">
          {participantFile?.type?.template ? (
            <DocumentsActionButton
              label={t("Download Template")}
              disabled={isStatusPendingApproval(code)}
              icon={Template}
              onClick={() => download(participantFile?.type?.template)}
            />
          ) : null}
          <Button
            onClick={() => {
              setCurrentFile(participantFile);
              setIsUploadModalOpen(true);
            }}
            label={t("Upload")}
            type={"secondary"}
            additionalClassName="shadow-button"
          />
        </div>
      ) : null}
    </div>
  );
};
